import styled from "styled-components";
import { ContentContainerBase } from "../../common/components";
import { TextMS } from "../../common/text";
import { Swiper } from "swiper/react";
import { CenterContainer } from "../../common/components";

export const ContentContainer = styled(ContentContainerBase)`
  align-items: center;

  @media ${({ theme }) => theme.device.tablet} {
  }
`;

// 헤더를 제외한 영역 전체 차지
export const TicketDetailWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 90%;
  height: 100%;

  @media ${({ theme }) => theme.device.tablet} {
    width: 80%;
    height: 75%;
  }
`;

export const TicketTitle = styled(TextMS)`
  text-align: center;
`;

export const TicketImgWrapper = styled(CenterContainer)`
  width: 100%;
  height: 35%;
  align-items: center;
  justify-content: center;
  /* background-color: black; */
`;
export const SSwiper = styled(Swiper)`
  width: 100%;
  height: 300px;
  border-radius: 12px;
  background-color: #ffffff;
  .swiper-pagination-bullet-active {
    background-color: #f44b59;
  }
  @media ${({ theme }) => theme.device.tablet} {
    height: 400px;
  }
`;

export const TicketImg = styled.img`
  width: 100%;
  height: 300px;
  display: flex;
  justify-content: center;
  @media ${({ theme }) => theme.device.tablet} {
    height: 400px;
  }
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  gap: 10px;
  margin-top: 20px;
  @media ${({ theme }) => theme.device.tablet} {
    gap: 20px;
  }
`;

export const ButtonIcon = styled.img`
  width: 30px;
  height: 30px;
  display: flex;
  background-color: none;
  @media ${({ theme }) => theme.device.tablet} {
    width: 40px;
    height: 40px;
  }
`;

// Ver.1 (배경 있음)

export const BarcodeBtn = styled.div`
  -webkit-user-select: none;
  width: 50%;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  background-color: #f44b59;
  &:active {
    background-color: #e84661;
  }
  border-radius: 5px;
  @media ${({ theme }) => theme.device.tablet} {
    width: 650px;
    height: 100px;
  }
`;

// export const CancelBtn = styled.div`
//   width: 50%;
//   height: 70px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   gap: 20px;
//   background-color: rgba(234, 234, 234, 0.4);
//   border-radius: 5px;
//   @media ${({ theme }) => theme.device.tablet} {
//     width: 650px;
//     height: 100px;
//   }
// `;

// Ver.2 (배경 없음)
// export const BarcodeBtn = styled.div`
//   width: 50%;
//   height: 70px;
//   display: flex;
//   justify-content: center;
//   align-items: center;
//   gap: 20px;
//   border: 2px solid #f44b59;
//   border-radius: 5px;
//   @media ${({ theme }) => theme.device.tablet} {
//     width: 650px;
//     height: 100px;
//   }
// `;

export const CancelBtn = styled.div`
  width: 50%;
  height: 60px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  border: 2px solid #eaeaea;
  border-radius: 5px;
  @media ${({ theme }) => theme.device.tablet} {
    width: 650px;
    height: 100px;
  }
`;

export const TicketTextWrapper = styled(TicketDetailWrapper)`
  width: 100%;
  overflow: scroll;

  ::-webkit-scrollbar {
    width: 0;
  }
`;
export const TicketText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 7px;
`;
